import {
  Box,
  Card,
  CardContent,
  Checkbox,
  Collapse,
  Fade,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPricingdiff,
  isArrayWithValues,
  isObjWithValues,
} from "../../helper";
import { addUserActivity } from "../../redux/actions/hubActions";
import { currencySymbols, PurityCard } from "./Gold";

const defaultPricing = {
  default: "",
  automatic: {
    650: { base: "", margin: 650, rate: "" },
    925: { base: "", margin: 925, rate: "" },
    995: { base: "", margin: 995, rate: "" },
    999: { base: "", margin: 999, rate: "" },
    750: { base: "", margin: 750, rate: "" },
    850: { base: "", margin: 850, rate: "" },
  },
  manual: {
    650: { base: "", rate: "" },
    925: { base: "", rate: "" },
    995: { base: "", rate: "" },
    999: { base: "", rate: "" },
    750: { base: "", rate: "" },
    850: { base: "", rate: "" },
  },
  enabled_purities: {
    650: true,
    925: true,
    995: true,
    999: true,
    750: true,
    850: true,
  },
};

const defaultPricingObj = {
  INR: defaultPricing,
  USD: defaultPricing,
  EUR: defaultPricing,
  GBP: defaultPricing,
  AUD: defaultPricing,
  AED: defaultPricing,
  SGD: defaultPricing,
  SAR: defaultPricing,
  ZAR: defaultPricing,
  CAD: defaultPricing,
  JPY: defaultPricing,
  CNY: defaultPricing,
  VND: defaultPricing,
  THB: defaultPricing,
  KWD: defaultPricing,
};

const Silver = forwardRef((props, ref) => {
  let { selectedCurrency: currency } = props;
  const [type, setType] = useState("automatic");
  const [from, setFrom] = useState("gross");
  const [silverPurities, setSilverPurities] = useState([]);
  const [pricing, setPricing] = useState(defaultPricingObj);
  // const [currency, selectedCurrency] = useState("");
  let { changePurity, onPricngChange } = props;
  const [allCurrency, setAllCurrency] = useState([]);
  const masterPricing = useSelector((state) => state.settings.masterPricing);
  const onlyChats = useSelector((state) => state.helper.onlyChats);
  const user_products = useSelector(
    (state) => state.user?.store_plan?.user_products
  );
  const dispatch = useDispatch();
  useImperativeHandle(ref, () => ({
    getSilverPricing(updateDiff) {
      let obj = {};
      for (let i = 0; i < allCurrency.length; i++) {
        let currencyObj = pricing[allCurrency[i].value];
        let enabled_purities = {};
        for (let j = 0; j < silverPurities.length; j++) {
          enabled_purities[silverPurities[j].value] =
            currencyObj.enabled_purities[silverPurities[j].value];
        }
        obj[allCurrency[i].value] = { ...currencyObj, enabled_purities };
      }
      // for (let i = 0; i < allCurrency.length; i++) {
      //   obj[allCurrency[i].value] = pricing[allCurrency[i].value];
      // }
      let oldPricingObj = masterPricing?.silver_pricing;
      let defaultPurityAmount = oldPricingObj?.[currency]?.[type];
      let diffrenceObj = getPricingdiff(
        defaultPurityAmount,
        obj?.[currency]?.[type]
      );
      let event_info = {};

      for (const purity of changePurity?.silver) {
        let diffrenceObjpurity = diffrenceObj[purity] || {};
        event_info = { ...event_info, [purity]: diffrenceObjpurity };
      }
      if (
        isObjWithValues(diffrenceObj) &&
        isObjWithValues(event_info) &&
        isArrayWithValues(changePurity?.silver)
      ) {
        updateDiff &&
          updateDiff({
            silver: event_info,
          });
        dispatch(
          addUserActivity({
            event: `pricing_update`,
            currency,
            event_info: {
              silver: event_info,
            },
          })
        );
      }
      return { ...obj, from, type };
    },
  }));

  useEffect(() => {
    if (isObjWithValues(props.productSettings))
      if (isArrayWithValues(props.productSettings.currency)) {
        let { currency } = props.productSettings;
        // selectedCurrency(currency[0].value);
        setAllCurrency(props.productSettings.currency);
      }
  }, [props.productSettings]);

  useEffect(() => {
    if (
      isObjWithValues(masterPricing) &&
      isObjWithValues(masterPricing.silver_pricing)
    ) {
      setPricing((state) => ({ ...state, ...masterPricing.silver_pricing }));
      let { from, type } = masterPricing.silver_pricing;
      setFrom(from);
      setType(type);
    }
  }, [masterPricing]);

  useEffect(() => {
    if (isArrayWithValues(props.silverPurities))
      setSilverPurities(props.silverPurities);
  }, [props.silverPurities]);

  const onDefaultChange = (value) => {
    let obj = { ...pricing[currency][type][value] };
    if (obj) {
      obj.margin = Number(value);
      obj.rate = obj.base;
    }
    setPricing((state) => ({
      ...state,
      [currency]: {
        ...state[currency],
        [type]: { ...state[currency][type], [value]: obj },
        default: state[currency].default === value ? "" : value,
      },
    }));
  };

  const onBaseAmountChange = (purity, amount, dontChangeOtherPurities) => {
    let obj = { ...pricing[currency][type][purity] };
    obj.base = amount;
    obj.rate = amount;
    if (type === "automatic") {
      if (Number(obj.margin))
        obj.rate = parseFloat(
          (Number(amount) * Number(obj.margin)) / Number(purity)
        ).toFixed(2);
      if (!dontChangeOtherPurities) {
        let purities = Object.keys(pricing[currency]?.enabled_purities).filter(
          (i) => i !== purity
        );
        for (let i = 0; i < purities.length; i++) {
          let otherPurityAmount = parseFloat(
            (Number(amount) * Number(purities[i])) / Number(obj.margin)
          ).toFixed(2);
          onBaseAmountChange(purities[i], otherPurityAmount, true);
        }
      }
    }
    setPricing((state) => ({
      ...state,
      [currency]: {
        ...state[currency],
        [type]: { ...state[currency][type], [purity]: obj },
      },
    }));
  };
  const onMarginChange = (purity, value) => {
    let obj = { ...pricing[currency][type][purity] };
    obj.margin = value;
    if (type === "automatic") {
      if (Number(obj.margin)) {
        obj.rate = parseFloat(
          (Number(obj.base) * Number(value)) / Number(purity)
        ).toFixed(2);
      }
    }
    setPricing((state) => ({
      ...state,
      [currency]: {
        ...state[currency],
        [type]: { ...state[currency][type], [purity]: obj },
      },
    }));
  };

  const onPurityChange = (obj) => {
    setPricing((state) => ({
      ...state,
      [currency]: {
        ...state[currency],
        enabled_purities: {
          ...state[currency]?.enabled_purities,
          [obj.value]: !state[currency]?.enabled_purities[obj.value],
        },
      },
    }));
  };
  return (
    <Box>
      {/* {onlyChats || user_products?.includes("whatsapp") ? null : ( */}
      {false ? null : (
        <Grid container spacing={3} style={{ marginTop: "10px" }}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                borderRadius: "10px",
                boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)",
              }}
            >
              <CardContent
                sx={{
                  "&:last-child": { paddingBottom: "16px" },
                }}
              >
                <Stack
                  alignItems={"center"}
                  justifyContent="space-between"
                  direction="row"
                  // p={2}
                  // border="0.5px solid #d1d1d1 "
                  // borderRadius={"6px"}
                >
                  <Typography>How do you want to set price?</Typography>
                  <FormControl size="small">
                    {/* <InputLabel id="demo-simple-select-label">Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={type}
                      // label="Age"
                      onChange={(e) => setType(e.target.value)}
                    >
                      <MenuItem value={"automatic"}>Automatic</MenuItem>
                      <MenuItem value={"manual"}>Manual</MenuItem>
                    </Select>
                  </FormControl>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                borderRadius: "10px",
                boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)",
              }}
            >
              <CardContent
                sx={{
                  "&:last-child": { paddingBottom: "16px" },
                }}
              >
                <Stack
                  alignItems={"center"}
                  justifyContent="space-between"
                  direction="row"
                  // p={2}
                  // border="0.5px solid #d1d1d1 "
                  // borderRadius={"6px"}
                >
                  <Typography>Calculate silver pricing from?</Typography>
                  <FormControl size="small">
                    {/* <InputLabel id="demo-simple-select-label">Age</InputLabel> */}
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={from}
                      // label="Age"
                      onChange={(e) => setFrom(e.target.value)}
                    >
                      <MenuItem value={"gross"}>Gross</MenuItem>
                      <MenuItem value={"net"}>Net</MenuItem>
                    </Select>
                  </FormControl>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
      {/* <Card>
        <CardContent></CardContent>
      </Card> */}
      <Grid
        container
        spacing={2}
        justifyContent={"space-between"}
        alignItems="center"
        style={{ marginTop: "13px" }}
      >
        <Grid item>
          <Stack direction="row" alignItems={"center"} flexWrap="wrap">
            {silverPurities.map((i) => {
              return (
                <PurityCard
                  key={i.value}
                  obj={i}
                  isSelected={pricing[currency]?.enabled_purities[i.value]}
                  onClick={onPurityChange}
                />
              );
            })}
          </Stack>
        </Grid>
        {/* <Grid item>
          <FormControl size="small">
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={currency}
              // label="Age"
              onChange={(e) => selectedCurrency(e.target.value)}
            >
              {allCurrency.map((i) => {
                return (
                  <MenuItem
                    value={i.value}
                  >{`${i.label} (${i.symbol})`}</MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid> */}
      </Grid>
      <Grid container spacing={3} sx={{ marginTop: "14px" }}>
        {Array.isArray(silverPurities) &&
          silverPurities.map((purity) => {
            if (!pricing[currency]?.enabled_purities[purity.value]) return null;
            return (
              <Grid item xs={12} md={6} lg={4}>
                <PricingCard
                  title={purity.label}
                  purity={purity.value}
                  baseAmount={pricing[currency]?.[type]?.[purity.value]?.base}
                  rateAmount={pricing[currency]?.[type]?.[purity.value]?.rate}
                  margin={pricing?.[currency]?.[type]?.[purity.value]?.margin}
                  onMarginChange={onMarginChange}
                  onBaseAmountChange={onBaseAmountChange}
                  defaultValue={pricing[currency].default}
                  onDefaultChange={onDefaultChange}
                  type={type}
                  currency={currency}
                  onPricngChange={onPricngChange}
                />
              </Grid>
            );
          })}
        {/* <Grid item xs={12} md={6} lg={4}>
          <PricingCard title="22 KT (999)" />
        </Grid> */}
      </Grid>
    </Box>
  );
});

export default Silver;

const PricingCard = ({
  title,
  purity,
  defaultValue,
  onDefaultChange,
  baseAmount,
  rateAmount,
  onBaseAmountChange,
  margin,
  onMarginChange,
  type,
  currency,
  onPricngChange,
}) => {
  return (
    <Card
      style={{
        borderRadius: "10px",
        boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)",
      }}
    >
      <CardContent>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6">{title}</Typography>
          {/* <Fade in={type === "automatic"}>
          </Fade> */}
          <FormControlLabel
            value="end"
            control={
              <Checkbox
                checked={defaultValue === purity}
                onChange={(e) => onDefaultChange(purity)}
              />
            }
            label="Set Default"
            labelPlacement="start"
          />
        </Stack>
        <Stack
          direction="row"
          justifyContent={"space-between"}
          alignItems={"center"}
          mt={3}
        >
          <Typography variant="body2">Price</Typography>
          <TextField
            type="number"
            size="small"
            value={baseAmount}
            onChange={(e) => {
              onBaseAmountChange(purity, e.target.value);
              onPricngChange("silver", purity);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {currencySymbols[currency]}
                </InputAdornment>
              ),
            }}
          />
        </Stack>
        <Collapse in={type === "automatic"}>
          <Box sx={{ px: 3, pt: 1 }}>
            <Slider
              // aria-label="Restricted values"
              // defaultValue={20}
              // valueLabelFormat={valueLabelFormat}
              // getAriaValueText={valuetext}
              disabled={defaultValue === purity}
              value={margin}
              onChange={(e, value) => onMarginChange(purity, value)}
              valueLabelDisplay="on"
              step={null}
              sx={{ transform: "translateY(35px)" }}
              defaultValue={Number(purity)}
              // scale={() => " "}
              componentsProps={{ markLabel: { style: { display: "none" } } }}
              marks={marks[purity]}
              min={marks[purity][0].value}
              max={marks[purity][marks[purity].length - 1].value}
              aria-labelledby="non-linear-slider"
            />
          </Box>
        </Collapse>
        <Stack mt={3} justifyContent={"flex-end"} direction="row">
          <Typography
            variant="body1"
            sx={{ fontSize: "15px", fontWeight: 700 }}
          >
            Sell: {currencySymbols[currency]} {rateAmount || 0}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

const marks = {
  650: [
    { label: "600", value: 600 },
    { label: "610", value: 610 },
    { label: "620", value: 620 },
    { label: "630", value: 630 },
    { label: "640", value: 640 },
    { label: "650", value: 650 },
    { label: "655", value: 655 },
    { label: "660", value: 660 },
    { label: "665", value: 665 },
    { label: "670", value: 670 },
    { label: "675", value: 675 },
    { label: "680", value: 680 },
    { label: "685", value: 685 },
    { label: "690", value: 690 },
    { label: "695", value: 695 },
    { label: "700", value: 700 },
    { label: "705", value: 705 },
    { label: "710", value: 710 },
    { label: "715", value: 715 },
    { label: "720", value: 720 },
    { label: "725", value: 725 },
    { label: "730", value: 730 },
    { label: "735", value: 735 },
    { label: "740", value: 740 },
    { label: "745", value: 745 },
  ],
  750: [
    { label: "700", value: 700 },
    { label: "710", value: 710 },
    { label: "720", value: 720 },
    { label: "730", value: 730 },
    { label: "740", value: 740 },
    { label: "750", value: 750 },
    { label: "755", value: 755 },
    { label: "760", value: 760 },
    { label: "765", value: 765 },
    { label: "770", value: 770 },
    { label: "775", value: 775 },
    { label: "780", value: 780 },
    { label: "785", value: 785 },
    { label: "790", value: 790 },
    { label: "795", value: 795 },
    { label: "800", value: 800 },
    { label: "805", value: 805 },
    { label: "810", value: 810 },
    { label: "815", value: 815 },
    { label: "820", value: 820 },
    { label: "825", value: 825 },
    { label: "830", value: 830 },
    { label: "835", value: 835 },
    { label: "840", value: 840 },
    { label: "845", value: 845 },
  ],
  850: [
    { label: "800", value: 800 },
    { label: "810", value: 810 },
    { label: "820", value: 820 },
    { label: "830", value: 830 },
    { label: "840", value: 840 },
    { label: "850", value: 850 },
    { label: "855", value: 855 },
    { label: "860", value: 860 },
    { label: "865", value: 865 },
    { label: "870", value: 870 },
    { label: "875", value: 875 },
    { label: "880", value: 880 },
    { label: "885", value: 885 },
    { label: "890", value: 890 },
    { label: "895", value: 895 },
    { label: "900", value: 900 },
    { label: "905", value: 905 },
    { label: "910", value: 910 },
    { label: "915", value: 915 },
    { label: "920", value: 920 },
    { label: "925", value: 925 },
    { label: "930", value: 930 },
    { label: "935", value: 935 },
    { label: "940", value: 940 },
    { label: "945", value: 945 },
  ],
  999: [
    { label: "960", value: 960 },
    { label: "970", value: 970 },
    { label: "980", value: 980 },
    { label: "990", value: 990 },
    { label: "999", value: 999 },
    { label: "1000", value: 1000 },
  ],
  995: [
    { label: "950", value: 950 },
    { label: "960", value: 960 },
    { label: "970", value: 970 },
    { label: "980", value: 980 },
    { label: "990", value: 990 },
    { label: "995", value: 995 },
    { label: "1000", value: 1000 },
  ],
  925: [
    { label: "860", value: 860 },
    { label: "870", value: 870 },
    { label: "880", value: 880 },
    { label: "890", value: 890 },
    { label: "900", value: 900 },
    { label: "910", value: 910 },
    { label: "920", value: 920 },
    { label: "925", value: 925 },
    { label: "930", value: 930 },
    { label: "935", value: 935 },
    { label: "940", value: 940 },
    { label: "945", value: 945 },
    { label: "950", value: 950 },
    { label: "955", value: 955 },
    { label: "960", value: 960 },
    { label: "965", value: 965 },
    { label: "970", value: 970 },
    { label: "975", value: 975 },
    { label: "980", value: 980 },
    { label: "985", value: 985 },
    { label: "990", value: 990 },
    { label: "995", value: 995 },
    { label: "1000", value: 1000 },
  ],
};
